import {Box, Text, Link as ChakraLink, HStack, Icon, CloseButton} from '@chakra-ui/react';
import {CheckCircleIcon} from '@chakra-ui/icons';

export const CustomToast = ({title, linkText, linkUrl, onClose}) => (
  <Box p={4} bg="green.500" color="white" borderRadius="md" boxShadow="md">
    <HStack align="start" spacing={3}>
      <Icon as={CheckCircleIcon} w={5} h={5} />
      <Box>
        <Text fontWeight="bold">{title}</Text>
        {linkText && linkUrl && (
          <ChakraLink href={linkUrl} isExternal textDecoration="underline">
            {linkText}
          </ChakraLink>
        )}
      </Box>
      <CloseButton onClick={onClose} color="white" />
    </HStack>
  </Box>
);
